import { CatalogUpsellTextAlign } from "@/data/catalog";
import { useMediaQuery } from "@/hooks";
import { useI18n } from "@/lib/i18n/i18n_provider";
import classNames from "classnames";
import React from "react";
import { Button } from "react-bootstrap";

interface HeroProps {
  imageUrl: string;
  title: string;
  description: string;
  longDescription?: string;
  buttonLabel?: string;
  onClickButton?: React.MouseEventHandler<HTMLButtonElement>;
  buttonUrl?: string;
  textAlign?: CatalogUpsellTextAlign;
}

export function Hero(props: HeroProps) {
  const {
    imageUrl,
    title,
    description,
    longDescription,
    buttonLabel,
    onClickButton,
    buttonUrl,
    textAlign,
  } = props;
  const { device } = useMediaQuery();
  const { fbt } = useI18n();

  return (
    <div
      style={{ textAlign }}
      className={classNames(
        "d-flex flex-column ",
        textAlign === "center" && "align-items-center",
        textAlign === "end" && "align-items-end"
      )}
    >
      <img
        className="rounded w-100 object-fit-cover"
        style={{ height: device === "mobile" ? 200 : 400 }}
        src={imageUrl}
        alt={title}
      />
      <div className={classNames("mt-4", device !== "mobile" && "w-75")}>
        <h1>{title}</h1>
        <div>
          {longDescription ? (
            <div dangerouslySetInnerHTML={{ __html: longDescription }} />
          ) : (
            <div>{description}</div>
          )}
        </div>
        {!!buttonUrl?.length && (
          <a href={buttonUrl} target="_blank" rel="noopener noreferrer">
            <Button variant="primary" className="mt-3" onClick={onClickButton}>
              {buttonLabel || fbt("Learn more")}
            </Button>
          </a>
        )}
      </div>
    </div>
  );
}
